import { requireAnyOrgPermission, requireAnySystemPermission } from '../../backend/features/permissions/shared';
import { useUserState } from './useUserState';
export function usePermission() {
    const userState = useUserState();
    const handleRequireAnySystemPermission = (...requireAnyPermissions) => {
        return requireAnySystemPermission(userState, ...requireAnyPermissions);
    };
    const handleRequireAnyOrgPermission = (...requireAnyPermissions) => {
        return requireAnyOrgPermission(userState, ...requireAnyPermissions);
    };
    return {
        requireAnySystemPermission: handleRequireAnySystemPermission,
        requireAnyOrgPermission: handleRequireAnyOrgPermission,
        userState,
    };
}
